export type DeprecatedCustomerIntegrateRoutePageId =
  | "assets-2"
  | "asset:page-2"
  | "assets:all-2"
  | "assets:g-suite:create-2"
  | "assets:office-365:create-2"
  | "assets:kubernetes:agent:install-2"
  | "assets:kubernetes:agent:upgrade-2"
  | "assets:kubernetes:activate:eks-2"
  | "assets:kubernetes:activate:gke-2"
  | "assets:kubernetes:activate:bulk-2"
  | "assets:kubernetes:activate:eks:cloud-diagrams-2"
  | "settings:gcp-2"
  | "settings:gcp:new-2"
  | "settings:gcp:edit-2"
  | "settings:azure-2"
  | "settings:azure:new-2"
  | "settings:aws-2"
  | "settings:aws:link-2"
  | "settings:aws:account-2"
  | "datasets-2"
  | "datasets:details-2"
  | "integrations:zapier-2"
  | "integrations:slack-2"
  | "integrations:jira-2"
  | "integrations:ms-teams-2";

export type DeprecatedCustomerIntegrateRouteConfig = {
  pageId: DeprecatedCustomerIntegrateRoutePageId;
  route: string;
};

export const deprecatedCustomerIntegrateRoutes: DeprecatedCustomerIntegrateRouteConfig[] = [
  {
    pageId: "assets-2",
    route: "/assets",
  },
  {
    pageId: "asset:page-2",
    route: "/assets/:tab/:assetId",
  },
  {
    pageId: "assets:all-2",
    route: "/assets/:tab?/:assetId?/:transfer?",
  },
  {
    pageId: "assets:g-suite:create-2",
    route: "/assets/g-suite/create",
  },
  {
    pageId: "assets:office-365:create-2",
    route: "/assets/office-365/create",
  },
  {
    pageId: "assets:kubernetes:agent:install-2",
    route: "/assets/kubernetes/:clusterId/agent/install",
  },
  {
    pageId: "assets:kubernetes:agent:upgrade-2",
    route: "/assets/kubernetes/:clusterId/agent/upgrade",
  },
  {
    pageId: "assets:kubernetes:activate:eks-2",
    route: "/assets/kubernetes/activate/eks",
  },
  {
    pageId: "assets:kubernetes:activate:gke-2",
    route: "/assets/kubernetes/activate/gke",
  },
  {
    pageId: "assets:kubernetes:activate:bulk-2",
    route: "/assets/kubernetes/activate/bulk",
  },
  {
    pageId: "assets:kubernetes:activate:eks:cloud-diagrams-2",
    route: "/assets/kubernetes/activate/eks/cloud-diagrams",
  },
  {
    pageId: "settings:gcp-2",
    route: "/settings/gcp",
  },
  {
    pageId: "settings:gcp:new-2",
    route: "/settings/gcp/connect/:type(organization|project|dataset)",
  },
  {
    pageId: "settings:gcp:edit-2",
    route: "/settings/gcp/connect/:type(organization|project|dataset)/:id",
  },
  {
    pageId: "settings:azure-2",
    route: "/settings/azure",
  },
  {
    pageId: "settings:azure:new-2",
    route: "/settings/azure/connect",
  },
  {
    pageId: "settings:aws-2",
    route: "/settings/aws",
  },
  {
    pageId: "settings:aws:link-2",
    route: "/settings/aws/link",
  },
  {
    pageId: "settings:aws:account-2",
    route: "/settings/aws/:accountId",
  },
  {
    pageId: "datasets-2",
    route: "/datasets",
  },
  {
    pageId: "datasets:details-2",
    route: "/datasets/:datasetName?",
  },
  {
    pageId: "integrations:zapier-2",
    route: "/integrations/zapier",
  },
  {
    pageId: "integrations:slack-2",
    route: "/integrations/slack",
  },
  {
    pageId: "integrations:jira-2",
    route: "/integrations/jira",
  },
  {
    pageId: "integrations:ms-teams-2",
    route: "/integrations/msteams",
  },
];
